import React from "react";
import { GraduationCap, Users, Sparkles, LucideCircleCheck } from "lucide-react";
import { Divider } from "antd";

export default function EnrolleeDetails({ selectedCourse, selectedMembers = [] }) {

  const courseName = selectedCourse?.title || "No course selected";
  const level = selectedCourse?.level || "N/A";
  const startDate = selectedCourse?.startDate || "TBA";
  const duration = selectedCourse?.duration || "TBA";
  const instructor = selectedCourse?.instructor || "TBA";

  return (
    <div className="space-y-6">
      <div className="p-5 rounded-xl bg-gradient-to-br from-purple-50 to-indigo-50 border-2 border-purple-200 dark:from-purple-900 dark:to-white/10 dark:border-purple-700">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-xl bg-purple-500">
            <GraduationCap className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-semibold text-[16px] dark:text-white">Course Details</h3>
        </div>

        <div className="text-[14px]">
          <div className="flex justify-between">
            <p className="text-slate-700 dark:text-slate-100">Course:</p>
            <p className="font-semibold dark:text-white">{courseName}</p>
          </div>

          <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

          <div className="grid grid-cols-2 gap-3">
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-slate-700 dark:text-slate-100">Start Date:</p>
                <p className="font-semibold dark:text-white">{startDate}</p>
              </div>

              <div>
                <p className="text-slate-700 dark:text-slate-100">Level:</p>
                <p
                  className={`inline-flex text-xs status-indicator  ${
                    level.toLowerCase().replace(/\s+/g, "-")
                  }`}
                >
                  {level}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <div>
                <p className="text-slate-700 dark:text-slate-100">Duration:</p>
                <p className="font-semibold dark:text-white">{duration}</p>
              </div>

              <div>
                <p className="text-slate-700 dark:text-slate-100">Instructor:</p>
                <p className="font-semibold dark:text-white">{instructor}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 rounded-2xl bg-gradient-to-br from-emerald-50 to-cyan-50 border-2 border-emerald-200 dark:from-emerald-900 dark:to-white/10 dark:border-emerald-700">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-xl bg-emerald-500">
            <Users className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-semibold text-[16px] dark:text-white">
            Team Members ({selectedMembers.length})
          </h3>
        </div>

        <div className="space-y-2 max-h-[185px] overflow-y-auto">
          {selectedMembers.length > 0 ? (
            selectedMembers.map((member) => (
              <div
                key={member.id}
                className="flex items-center gap-2 p-2 rounded-xl bg-white border border-emerald-200 dark:bg-white/10"
              >
                <div className="flex items-center justify-center w-8 h-8 rounded-full gradient icon-emerald border-2 border-emerald-200 text-white text-[10px] font-semibold">
                  {member.initial}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-[13px] font-semibold truncate dark:text-white">
                    {member.name || "Unnamed Member"}
                  </p>
                  <p className="text-[11px] text-slate-700 truncate dark:text-slate-200">
                    {member.role || "Team Member"}
                  </p>
                </div>
                <LucideCircleCheck
                  size={16}
                  className="text-emerald-600 flex-shrink-0 dark:text-emerald-100"
                />
              </div>
            ))
          ) : (
            <p className="text-sm text-slate-700">
              No team members selected.
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 p-4 rounded-xl bg-slate-50 border border-slate-200 text-[13px] text-slate-700 text-center dark:bg-amber-50/10 dark:text-slate-200">
        <Sparkles className="w-4 h-4 text-amber-600 dark:text-amber-400" />
        All team members will receive enrollment confirmation via email
      </div>
    </div>
  );
}
